import { isValid } from "postcss-import/lib/data-url";
import { createEffect, createMemo, createSignal, Match, onCleanup, onMount, Switch } from "solid-js";
import { createStore } from "solid-js/store";
import { CloseIcon } from "../components/CloseIcon";
import { twMerge } from "tailwind-merge";
import { getPriceFormatted, removeHiphen, titleCase } from "../js/itemPropsHelper";
import { CheckIcon } from "../components/CheckIcon";
import { ModalV2, ModalV3 } from "../components/Modal";
import { batch } from "solid-js";
import { RightArrow } from "../components/RightArrowIcon";
import { InfoIcon } from "../components/InfoIcon";

const OptionThumbnail = (props) => {

  return (
    <div
      class={twMerge(
        "size-6 sm:size-8 inline-svg-container",
        props.class ?? ""
      )}
    // innerHTML={imgSrc}
    >
      <img src={props.imgSrc} />
    </div>
  )
}

const TextField = (props) => {
  const [isValid, setIsValid] = createSignal(false);
  let fieldRef;
  const id = handleize(props.field.label ?? "");
  const validate = (propValue = undefined) => {
    const value = propValue ?? fieldRef.value;

    if (!props.field.validation) return true;
    const isValid = new RegExp(props.field.validation).test(value)

    setIsValid(isValid);

    const validationMatch = props.field.validation?.replace('$', '');

    if (!isValid) {
      const valueMatch = value?.match(validationMatch) ?? "";
      const newValue = typeof (valueMatch) == 'object' ? valueMatch?.[0] : valueMatch;
      batch(() => {
        if (props.value == newValue) {
          props.onChange(".");
        }
        props.onChange(newValue);
      })
      return isValid;
    }

    props.onChange(value);
    return isValid;
  }

  onMount(() => {
    validate(props.value);
  });

  return (
    <div id={id}>
      <div class="font-semibold">{props.field.label}
        <Show when={props.field.required}><span class="ml-0.5 text-xs text-error-900">*</span></Show>
      </div>
      <div class="flex items-center gap-1">
        <input
          ref={fieldRef}
          type="text"
          pattern={props.field.validation}
          onInput={() => validate()}
          class="my-1 p-1 border-ink bg-transparent border border-solid w-fit"
          // classList={{
          //   "border-error-700": !isValid(),
          //   "border-ink": isValid()
          // }}
          value={props.value ?? ""}
          onChange={({ target }) => props.onChange(target.value)}
        />
        {/* <button type="button" onClick={handleErase}>
          <CloseIcon />
        </button> */}
      </div>
      <Show when={props.field.info}>
        <div class="text-2xs">{props.field.info}</div>
      </Show>
      {/* <Show when={!isValid()}>
        <div class="text-2xs text-error-700">{props.field.validationError}</div>
      </Show> */}
    </div>
  )
}

const ColorField = (props) => {
  const id = handleize(props.field.label);
  const onClick = (id) => {
    props.onChange(id)
  }

  return (
    <div id={id}>
      <div class="font-semibold">{props.field.label}</div>
      <div class="flex gap-1">
        <For each={props.field.options}>{(option) => {
          return (
            <div
              class="w-3 h-3 rounded-full cursor-pointer"
              classList={{
                "border border-solid border-ink shadow-[inset_0px_0px_0px_2px_rgb(255_255_255)]": option.id == props.value
              }}
              style={`background-color: ${option.hex};`}
              onClick={() => onClick(option.id)}
            />
          )
        }}</For>
      </div>
    </div>
  )
}

const RadioField = (props) => {
  const id = handleize(props.field.label);
  const chargeVariant = props.chargeVariant;

  return (
    <div id={id}>
      <div class="font-semibold">{props.field.label}</div>
      <div class=" grid grid-cols-[repeat(auto-fill,_minmax(110px,_1fr))] gap-1.5 mt-0.5 cursor-pointer">
        <For each={props.field.options}>{(option) => {
          const optionChargeVariant = option.chargeVariant;
          const variantPrice = props.index == 0 ? ((optionChargeVariant?.price ?? 0) + (chargeVariant?.price ?? 0)) : optionChargeVariant?.price ?? chargeVariant?.price ?? null;
          const priceFormatted = variantPrice ? getPriceFormatted(variantPrice / 100) : null;

          return (
            <div class="flex items-center gap-0.5">
              <input
                id={option.id}
                class={`hidden design-option-input-element`}
                name={id}
                value={option.id}
                type="radio"
                onClick={() => props.onChange(option.id)}
                checked={props.value == option.id}
              />
              <label
                for={option.id}
                class="flex gap-0.5 cursor-pointer items-center w-full"
              // classList={{
              //   "bg-canvas-light": isSelected()
              // }}
              >
                <Show
                  when={props.value == option.id}
                  fallback={(
                    <div class="w-[14px] h-[14px] p-[5px] border border-ink rounded-full" />
                  )}
                >
                  <CheckIcon size={14} />
                </Show>
                <div class="flex flex-col w-full gap-0.5">
                  <Show when={option.image}>
                    <img
                      class="lazyload w-full h-fit max-h-8 bg-white" // w-full aspect-[11/4] 
                      src={`${option.image}&width=24`}
                      data-srcset={[34, 49, 58, 68, 102, 116, 174]
                        .map((width) => `${option.image}&width=${width} ${width}w`)
                        .join(", ")}
                    />
                  </Show>
                  <div class="flex justify-between text-2xs gap-1 items-center">
                    <div>{props.field.show_label ? option.label : ""}</div>
                    <Show when={optionChargeVariant != null || (props.index == 0 && props.field.show_price && priceFormatted != null)}>
                      <div class="text-2xs">{option.id == "none" ? "Free" : `+${priceFormatted}`}</div>
                    </Show>
                  </div>
                </div>
              </label>
            </div>
          )
        }}</For>
      </div>
    </div>
  )
}

export const AccentFields = (props) => {
  return (
    <For each={props.fields}>{(field, index) => {
      const fieldId = handleize(field.label);

      return (
        <div class="py-2" classList={{
          "border-b border-ink": index() + 1 != props.fields.length
        }}>
          <Switch>
            <Match when={field.type == 'text'}>
              <TextField
                field={field}
                value={props.inputs?.[fieldId]}
                onChange={(value) => props.handleOptionInputsChange(props.id, fieldId, value)}
              />
            </Match>
            <Match when={field.type == 'color_radio'}>
              <ColorField
                field={field}
                value={props.inputs?.[fieldId]}
                onChange={(value) => props.handleOptionInputsChange(props.id, fieldId, value)}
              />
            </Match>
            <Match when={field.type == 'radio'}>
              <RadioField
                field={field}
                value={props.inputs?.[fieldId]}
                onChange={(value) => props.handleOptionInputsChange(props.id, fieldId, value)}
              />
            </Match>
          </Switch>
        </div>
      )
    }}</For>
  )
}

const AccentCard = (props) => {
  const tooltip = undefined;
  const styleImageSrc = undefined;
  const className = props.className;
  const isSelected = () => props.selected;

  const option = props.option;
  const thumbnailSrc = option.thumbnailSrc;
  const id = handleize(option.label)
  const label = option.label;
  const fields = Object.values(option.fields ?? {});

  return (
    <div
      class="flex justify-center w-full flex-col"
      classList={{
        "boxy-shadow bg-canvas-light": isSelected(),
        "order-2": props.isDefault == false
      }}
    >
      <input
        id={id}
        class={`hidden design-option-input-element`}
        value={option.label}
        type="radio"
      />
      <label
        for={id}
        class={`bg-canvas  group relative flex w-full cursor-pointer items-stretch ${props.hideIcon ? 'justify-center' : 'justify-between'} hover:bg-canvas-light border border-solid border-frame p-1 sm:p-1 option-active min-w-max`}
        classList={{
          "bg-canvas-light": isSelected()
        }}
        onClick={() => props.handleOptionSelect(option.id)}
      >
        <div
          class={`flex ${styleImageSrc != undefined && styleImageSrc.trim().length > 0 ? "flex-col" : "flex-row items-center"} justify-between gap-1 w-full`}
        >
          {
            thumbnailSrc != undefined && thumbnailSrc.trim().length > 0 && props.hideIcon != true
              ? <OptionThumbnail
                imgSrc={thumbnailSrc}
                label={`${label} image`}
                class="shrink-0"
              />
              : null
          }
          <div class={`flex justify-between w-full`}>
            <span class={`${styleImageSrc != undefined && styleImageSrc.trim().length > 0 ? "text-lg  max-w-min text-left" : "text-sm text-center "} text-ink font-medium liga-off inline-block flex-grow-0 lg:w-auto ${className != undefined ? className : ""}`}>{option.label}</span>
            <Show when={option.chargeVariant?.price}>
              <span class="text-frame-light bg-frame-dark px-0.5 py-0.5 rounded-md text-2xs font-semibold">+{getPriceFormatted(option.chargeVariant.price / 100)}</span>
            </Show>
          </div>
        </div>
      </label>
      <Show when={fields.length > 0 && isSelected()}>
        <div class="py-1 px-3 flex flex-col border-x border-b border-frame">
          <AccentFields
            id={id}
            fields={fields}
            inputs={props.inputs}
            handleOptionInputsChange={props.handleOptionInputsChange}
          />
        </div>
      </Show>
    </div>
  )
}

export const AccentFieldsV2 = (props) => {
  const [isAccentActive, setIsAccentActive] = createSignal(props.selected);

  const handleOptionInputsChange = (id, fieldId, selected, stateChanger = false) => {
    props.handleOptionInputsChange(id, fieldId, selected);
    const isAccentActive = selected != 'none';
    setIsAccentActive(isAccentActive);
  }

  createEffect(() => {
    setIsAccentActive(props.selected);
  })

  return (
    <For each={props.fields}>{(field, index) => {
      const fieldId = handleize(field.label);

      return (
        <Show when={index() == 0 || isAccentActive()}>
          <div
            class="py-2 px-2"
            classList={{
              "border-b border-frame": index() + 1 != props.fields.length,
              "py-1": index() != 0
            }}
          >
            <Switch>
              <Match when={field.type == 'text'}>
                <TextField
                  field={field}
                  value={props.inputs?.[fieldId]}
                  onChange={(value) => handleOptionInputsChange(props.id, fieldId, value)}
                />
              </Match>
              <Match when={field.type == 'color_radio'}>
                <ColorField
                  field={field}
                  value={props.inputs?.[fieldId]}
                  chargeVariant={props?.option?.chargeVariant}
                  onChange={(value) => handleOptionInputsChange(props.id, fieldId, value)}
                />
              </Match>
              <Match when={field.type == 'radio'}>
                <RadioField
                  field={field}
                  index={index()}
                  value={props.inputs?.[fieldId]}
                  chargeVariant={props?.option?.chargeVariant}
                  onChange={(value) => handleOptionInputsChange(props.id, fieldId, value, index() == 0)}
                />
              </Match>
            </Switch>
          </div>
        </Show>
      )
    }}</For>
  )
}

const AccentCardV2 = (props) => {
  const option = props.option;
  const thumbnailSrc = option.thumbnailSrc;
  const id = handleize(option.label)
  const label = option.label;
  const fields = Object.values(option.fields ?? {});

  return (
    <div class={twMerge(
      "py-1 flex flex-col w-full",
      props.class ?? ""
    )}>
      <AccentFieldsV2
        id={id}
        option={option}
        selected={props.selected}
        fields={fields}
        inputs={props.inputs}
        handleOptionInputsChange={props.handleOptionInputsChange}
      />
    </div>
  )
}

export const AccentsContainer = (props) => {
  const accentSettings = props.accentSettings;

  return (
    <div class="flex border-t-0 border-solid border-frame relative flex-col items-stretch px-2 py-2 w-full gap-1">
      <For each={accentSettings.options}>{(option) => {
        return (
          <AccentCard
            option={option}
            selected={props.accentFormData.selected == option.id}
            inputs={props.accentFormData.option_inputs?.[option.id] ?? {}}
            handleOptionSelect={props.handlers.handleAccentSelect}
            handleOptionInputsChange={props.handlers.handleAccentInputsChange}
          />
        )
      }}</For>
    </div>

    // <div
    //   class="w-full flex flex-col border-b-inner border-solid border-frame px-2 py-2 cursor-pointer"
    //   onClick={() => {}}
    // >
    //   <div class="flex-auto flex justify-end items-center gap-2 pt-1">
    //     <Show
    //       when={
    //         true
    //       }
    //       fallback={<div class="h-5 w-5"></div>}
    //     >
    //       <div
    //         class="h-5 w-5 inline-svg-container text-ink"
    //         innerHTML={''}
    //       />
    //     </Show>
    //     <div className="flex flex-col grow items-stretch">
    //       <div class="flex-auto font-bold  text-base">
    //         No Monogram
    //       </div>
    //       {/* <div class="grow w-max">{selectedOption().label}</div> */}
    //     </div>
    //     <div>
    //       {/* <RightArrow /> */}
    //     </div>
    //   </div>
    // </div>
  )
}

export const AccentContainerV2 = (props) => {
  const accentSettings = props.accentSettings;
  const [modalState, setModalState] = createSignal(false);
  const handleModalOpenState = (state, isSave = false) => {
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = state ? 'hidden' : '';

    setModalState(state);
  }

  const [tempAccentFormData, setTempAccentFormData] = createStore(JSON.parse(JSON.stringify(props.accentFormData)))

  createEffect(() => {
    if (modalState()) {
      setTempAccentFormData(JSON.parse(JSON.stringify(props.accentFormData)))
    }
  })

  const handleAccentSelect = (optionId) => {
    setTempAccentFormData('selected', optionId);
  }
  const handleAccentInputsChange = (optionId, inputId, value) => {
    setTempAccentFormData('option_inputs', optionId, inputId, value);
  }

  onCleanup(() => {
    document.body.style.overflow = "";
  })

  const option = accentSettings.options?.[1];

  const changeAccentStatus = (state) => {
    const selectedId = accentSettings.options?.[state ? 1 : 0]?.id

    props.handlers.handleAccentSelect(selectedId);
    if (!state) {
      const firstField = Object.keys(accentSettings.options[1].fields)?.[0];
      props.handlers.handleAccentInputsChange(accentSettings.options[1].id, firstField, accentSettings.options[1].fields[firstField]?.default)
    }
  }

  const validateForm = () => {
    for (const fieldId of Object.keys(option.fields ?? {})) {
      const field = option.fields[fieldId];
      const validation = field?.validation;
      if (!validation) continue;
      const value = tempAccentFormData?.option_inputs?.[option.id]?.[fieldId] ?? ""
      const isValid = new RegExp(validation).test(value);

      if (!isValid)
        return fieldId;
    }
  }

  const saveAccent = () => {
    if (validateForm() != undefined) {
      return;
    }

    const fieldId = handleize(Object.values(option.fields)?.[0]?.label);

    const isAccentActive =
      (tempAccentFormData?.option_inputs?.[option.id]?.[fieldId] != 'none');

    if (!isAccentActive) {
      cancelAccent();
      return;
    };

    const inValidId = validateForm();
    if (inValidId != undefined) {
      document.querySelector(`#${inValidId}`)?.scrollIntoView({
        behavior: 'smooth'
      })
      return;
    }

    batch(() => {
      props.handlers.updateAccentInputs(tempAccentFormData.option_inputs)
      // const state = tempAccentFormData.selected != accentSettings.options[0]?.id;

      changeAccentStatus(true);
      handleModalOpenState(false)
    })
  }

  const cancelAccent = () => {
    batch(() => {
      changeAccentStatus(false);
      props.handlers.clearAccentCustomization();
      handleModalOpenState(false)
    })
  }

  const accentChargeVariant = createMemo(() => {
    return accentSettings.options?.find(option => option.id == props.accentFormData.selected)?.chargeVariant;
  })

  const accentCharge = createMemo(() => {
    const chargeVariant = accentChargeVariant();

    if (!chargeVariant) {
      const defaultChargeVariant = accentSettings.options?.find(option => option.chargeVariant != null)?.chargeVariant;
      return defaultChargeVariant ? `+${getPriceFormatted(defaultChargeVariant?.price / 100)}` : 'Free';
    }

    const chargeVariants = Object.entries(accentSettings.options?.find(option => option.id == props.accentFormData.selected)?.fields)
      .map(([fieldId, fieldInfo]) => {
        const fieldSelected = props.accentFormData.option_inputs?.[props.accentFormData.selected]?.[fieldId];
        const option = fieldInfo?.options?.find(option => option.id == fieldSelected);

        return option?.chargeVariant;
      })?.filter(variant => variant);
    const price = chargeVariant?.price + (chargeVariants?.map(variant => variant?.price).reduce((prev, curr) => prev + (curr ?? 0), 0));

    return `+${getPriceFormatted(price / 100)}`
  })

  const monogramInfo = createMemo(() => {
    const info = []
    const selected = props.accentFormData.selected;

    const optionInputs = props.accentFormData?.option_inputs?.[selected]
    const accentSetting = accentSettings.options?.find(option => option.id == selected);

    Object.keys(optionInputs ?? {}).forEach(cKey => {
      const label = titleCase(removeHiphen(cKey));
      const value = optionInputs?.[cKey];

      info.push({
        label,
        value,
        image_url: accentSetting.fields?.[cKey]?.options?.find(option => option.id == value)?.image ?? undefined,
        hexcode: accentSetting.fields?.[cKey]?.options?.find(option => option.id == value)?.hex ?? undefined
      })
    })

    return info
  })

  const monogramInfoWithImg = () =>
    monogramInfo().filter(info => info.image_url != undefined);

  const monogramInfoWithHex = () =>
    monogramInfo().filter(info => info.hexcode != undefined);

  const monogramInfoWithText = () =>
    monogramInfo().filter(info => (!info.image_url && !info.hexcode));

  const selectedOptionThumbnail = () => {
    const selected = props.accentFormData.selected;

    const selectedOption = accentSettings.options.find(option => option.id == selected)
    const defaultThumbnail = selectedOption?.thumbnailSrc;

    const firstFieldId = Object.keys(selectedOption?.fields ?? {})?.[0]
    const fieldSelected = props.accentFormData?.option_inputs?.[selected]?.[firstFieldId]
    const firstFieldSelectedThumbnail = Object.values(selectedOption?.fields ?? {})?.[0]?.options?.find(option => option.id == fieldSelected)?.image;
    const firstFieldDefaultThumnail = Object.values(accentSettings.options?.[1]?.fields)?.[0]?.options?.[0]?.image;

    return firstFieldSelectedThumbnail ?? firstFieldDefaultThumnail ?? defaultThumbnail
  }

  const isOptionSelected = () => {
    const selectedIndex = accentSettings.options?.findIndex(option => option.id == props.accentFormData.selected);

    return selectedIndex != 0;
  }

  const monogramInfoNote = () => accentSettings.info;

  console.log("accentSettings: ", accentSettings);

  return (
    <Show when={accentSettings.options?.length > 0}>
      <Show
        when={props.isCustomizationList}
        fallback={(
          <div
            class="max-w-lg p-2 border-frame flex flex-col"
            classList={{
              "cursor-pointer border-b bg-canvas": props.isCustomizationList,
              "mx-2 sm:mx-6 border boxy-shadow-sm bg-canvas-light": props.isCustomizationList != true
            }}
            {...(props.isCustomizationList ? { onClick: () => handleModalOpenState(true) } : {})}
          >
            <div class="flex justify-between items-center">
              <div class="flex flex-col">
                <div class="font-bold">{accentSettings.label}:</div>
                <Show when={monogramInfoNote()}>
                  <div class="relative inline-block group/tooltip text-xs text-tertiary-400">
                    <InfoIcon /> Note
                    <span
                      class="invisible w-25 bg-canvas-lighter text-ink text-center p-1 rounded-[4px] border border-frame absolute z-10 bottom-[125%] left-[50%] -ml-[60px] opacity-0 transition-opacity duration-300 after:content-[''] after:absolute after:top-full after:left-1/4 after:-ml-[5px] after:border-4 after:border-solid after:border-[#ddcbc0_transparent_transparent_transparent] group-hover/tooltip:visible group-hover/tooltip:opacity-100">
                      {monogramInfoNote()}
                    </span>
                  </div>
                </Show>
              </div>
              <div class="flex gap-1 items-center">
                <span
                  class="text-secondary-100 rounded-md px-1 py-0.5 text-2xs"
                  classList={{
                    "bg-[#B28E79]": !accentChargeVariant(),
                    "hidden": !accentChargeVariant() && props.isCustomizationList == true,
                    "bg-ink": accentChargeVariant()
                  }}
                >{accentCharge()}</span>
                <Show
                  when={props.isCustomizationList != true}
                  fallback={(
                    <RightArrow />
                  )}
                >
                  <Show
                    when={accentChargeVariant()}
                    fallback={(
                      <button type="button" onClick={() => handleModalOpenState(true)} class="underline hover:no-underline text-xs">Add</button>
                    )}
                  >
                    <button type="button" onClick={() => handleModalOpenState(true)} class="underline hover:no-underline text-xs">Change</button>
                    <button type="button" onClick={props.handlers.clearAccentCustomization} class="underline hover:no-underline text-xs">Remove</button>
                  </Show>
                </Show>
              </div>
            </div>
            <Show when={accentChargeVariant() && props.isCustomizationList != true}>
              <div class="text-xs flex flex-col flex-wrap gap-2 py-0.5 w-fit">
                <Show when={monogramInfoWithImg()?.length > 0}>
                  <div class="flex flex-wrap gap-2">
                    <For each={monogramInfoWithImg()}>{(info) => (
                      <div class="flex flex-col justify-between items-start gap-0.5">
                        <span
                          class="text-sm"
                        >{info.label}</span>
                        <img
                          class="h-7 sm:h-8 w-auto lazyload"
                          src={`${info.image_url}&width=24`}
                          data-srcset={[34, 49, 58, 68, 102, 116, 174]
                            .map((width) => `${info.image_url}&width=${width} ${width}w`)
                            .join(", ")}
                        />
                        <span class="text-2xs">{titleCase(removeHiphen(info.value))}</span>
                      </div>
                    )}</For>
                  </div>
                </Show>
                <Show when={monogramInfoWithHex()?.length > 0}>
                  <div class="flex flex-wrap gap-2">
                    <For each={monogramInfoWithHex()}>{(info) => (
                      <div class="flex items-center gap-0.5 text-sm">
                        <span>{info.label}: </span>
                        <span class="w-2 h-2 rounded-full" style={`background-color: ${info.hexcode};`} />
                      </div>
                    )}</For>
                  </div>
                </Show>
                <Show when={monogramInfoWithText()?.length > 0}>
                  <div class="flex flex-wrap gap-2">
                    <For each={monogramInfoWithText()}>{(info) => (
                      <div class="flex items-center gap-0.5 text-sm">
                        <span
                          class="font-semibold"
                        >{info.label}: </span>
                        <span>{info.value}</span>
                      </div>
                    )}</For>
                  </div>
                </Show>
              </div>
            </Show>
          </div>
        )}
      >
        <div
          class={
            twMerge(
              "w-full flex flex-col border-b-inner border-solid border-frame px-2 py-2 cursor-pointer",
              props.class ?? ""
            )
          }
          onClick={() => handleModalOpenState(true)}
        >
          <div class="flex-auto flex justify-end items-center gap-2 pt-1">
            <Show
              when={
                selectedOptionThumbnail() != undefined
              }
              fallback={<div class="h-5 w-5"></div>}
            >
              <img
                class="h-5 w-5 inline-svg-container text-ink" // w-full aspect-[11/4] 
                classList={{
                  "lazyload": selectedOptionThumbnail()
                }}
                src={selectedOptionThumbnail()}
              />
            </Show>
            <div className="flex flex-col grow items-stretch">
              <div class="flex-auto font-bold  text-base">
                {accentSettings.label}
              </div>
              <div class="grow w-max">{isOptionSelected() ? 'Yes' : 'No'}</div>
            </div>
            <div class="flex gap-1 items-center">
              <Show when={accentChargeVariant()}>
                <span
                  class="text-secondary-100 rounded-md px-1 py-0.5 text-2xs"
                  classList={{
                    "bg-[#B28E79]": !accentChargeVariant(),
                    "hidden": !accentChargeVariant() && props.isCustomizationList == true,
                    "bg-ink": accentChargeVariant()
                  }}
                >{accentCharge()}</span>
              </Show>
              <RightArrow />
            </div>
          </div>
        </div>
      </Show>
      <ModalV3
        title={accentSettings.label}
        isBacktrackHeader={props.isCustomizationList}
        modalState={modalState()}
        handleModalOpenState={(state) => {
          if (!state) {
            tempAccentFormData.selected
          }
          handleModalOpenState(state);
        }}
      >
        <AccentCardV2
          class="pb-8"
          option={option}
          selected={tempAccentFormData.selected == option.id}
          inputs={tempAccentFormData.option_inputs?.[option.id] ?? {}}
          handleOptionSelect={handleAccentSelect}
          handleOptionInputsChange={handleAccentInputsChange}
        />
        <div class="absolute bottom-0 left-0 right-0 flex gap-1 p-1 border-t border-frame bg-canvas">
          <button
            onClick={saveAccent}
            type="button"
            class="py-1 px-2 flex-grow text-base border font-bold flex justify-center items-center rounded-md max-w-sm border-ink text-canvas bg-ink "
            classList={{
              "opacity-40 cursor-default": validateForm() != undefined,
            }}
          >Save
          </button>
          {/* <button
            onClick={cancelAccent}
            type="button"
            class="py-1 px-2 flex-grow text-base border font-bold flex justify-center items-center rounded-md max-w-sm border-ink text-ink bg-canvas-light hover:bg-canvas-lighter"
          >Cancel
          </button> */}
        </div>
      </ModalV3>
    </Show>
  )
}